import { createFileRoute, Link } from "@tanstack/react-router";
import { TarifasSection } from "@/components/TarifasSection";
import { Breadcrumbs, breadcrumbJsonLd } from "@/components/Breadcrumbs";

export const Route = createFileRoute("/tarifas")({
  head: () => ({
    meta: [
      { title: "Tarifas · Casa rural El Pajar de Benito (Guadalajara)" },
      { name: "description", content: "Precios de la casa rural El Pajar de Benito: casa completa para 14 personas desde 690 € el fin de semana y habitaciones con baño privado desde 55 €/noche. Sin comisiones, reserva directa." },
      { property: "og:title", content: "Tarifas · Casa rural El Pajar de Benito (Guadalajara)" },
      { property: "og:description", content: "Casa completa para 14 personas desde 690 € el fin de semana · habitaciones con baño privado desde 55 €/noche. Reserva directa sin comisiones." },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://elpajardebenito.es/tarifas" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [{ rel: "canonical", href: "https://elpajardebenito.es/tarifas" }],
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify(
          breadcrumbJsonLd([
            { label: "Inicio", to: "/" },
            { label: "Tarifas", to: "/tarifas" },
          ]),
        ),
      },
    ],
  }),
  component: Tarifas,
});

function Tarifas() {
  return (
    <>
      <Breadcrumbs items={[{ label: "Inicio", to: "/" }, { label: "Tarifas" }]} />
      <section className="mx-auto max-w-4xl px-4 pt-20 pb-4 text-center md:px-6 md:pt-28">
        <p className="text-xs uppercase tracking-[0.28em] text-accent">Precios claros, sin comisiones</p>
        <h1 className="mt-4 font-serif text-4xl text-foreground md:text-5xl">
          Tarifas de la casa
        </h1>
        <p className="mt-6 text-lg leading-relaxed text-muted-foreground">
          Puedes alquilar la casa completa para 14 personas o una habitación con baño privado. El precio exacto de tus fechas lo verás al comprobar la disponibilidad, desglosado noche a noche.
        </p>
        <p className="mt-4 text-sm text-muted-foreground">
          ¿Cómo es la casa? <Link to="/alojamiento" className="underline underline-offset-4 hover:text-primary">Descubre el alojamiento</Link>
        </p>
      </section>
      <TarifasSection heading="Precios de temporada" />
    </>
  );
}
